import React, { useEffect } from 'react';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';
import './index.scss';
import { menus } from '../../routes';
import { LinkContainer } from 'react-router-bootstrap';
import { useHistory, Link } from 'react-router-dom';
import logo from '../../assets/image/logo.png';
import intl from "react-intl-universal";
import cookies from 'js-cookie';
import { intlGet } from '../../utils';


const clickSubMenu = (e: any) => {
  console.log('e', e.target);
  const aEl: HTMLAnchorElement = e.target;
  const parent = aEl.parentElement!.parentElement!;
  // parent.style.display = 'none';
  parent.classList.add('hide');

}

const onMouseEnter = (e: any) => {
  // console.log('onMouseEnter', e.target, e.currentTarget);
  const target: HTMLElement = e.currentTarget;
  const isParentMenu = target.tagName === 'DIV' && target.classList.contains('topParentMenu');
  if (isParentMenu) {
    target.classList.remove('hide');
  }
}


const addActiveClass = (path: string) => {
  const menuPath = path.split('/')[1];
  const menu = document.querySelector(`#menu-_${menuPath}`)!;
  if (menu) {
    menu.classList.add('active');
  }
}

const removeActiveClass = () => {
  const lastActiveEl = document.querySelector('.topParentMenu > a.active');
  const lastActiveEl2 = document.querySelector('.navbar-nav > a.active');
  if (lastActiveEl) {
    lastActiveEl.classList.remove('active');
  }
  if (lastActiveEl2) {
    lastActiveEl2.classList.remove('active');
  }
}


const mountMenus = (menus: Menu, parentPath = '') => {
  console.log('mountMenus');
  return Object.keys(menus).map(p => {
    const { path, title, children } = menus[p];

    if (children && Object.keys(children).length) {
      return <NavDropdown
        key={path}
        title={title}
        id={`menu-${path.replace('/', '_')}`}
        renderMenuOnMount={true}
        className="topParentMenu"
        onMouseEnter={onMouseEnter}
      >
        {mountMenus(children, path)}
      </NavDropdown>
    } else {
      const singPage = !parentPath;
      return singPage
        ? <LinkContainer key={path} to={path}>
          <Nav.Link id={`menu-${path.replace('/', '_')}`}>{title}</Nav.Link>
        </LinkContainer>
        : <LinkContainer key={path} to={path}>
          <NavDropdown.Item key={path} onClick={clickSubMenu} id={`menu-${path.replace('/', '_')}`}>
            {title}
          </NavDropdown.Item>
        </LinkContainer>
    }
  })

}

let menusTreeObj = mountMenus(menus);

const changeLanguage = () => {
  let currentLocale = intl.determineLocale({
    urlLocaleKey: "lang",
    cookieLocaleKey: "lang"
  });
  if (currentLocale === 'zh-CN') {
    currentLocale = 'en-US'
  } else {
    currentLocale = 'zh-CN'
  }
  window.location.search = `?lang=${currentLocale}`;
  cookies.set('lang', currentLocale);
}

let appEl: HTMLDivElement | null;
const scrollToTop = () => {
  if (!appEl) {
    appEl = document.querySelector<HTMLDivElement>('#root > .App');
  }
  if(appEl){
    appEl.scrollTo(0, 0);
  }
}

function Header() {
  const history = useHistory();

  useEffect(() => {
    const location = history.location;
    addActiveClass(location.pathname);

    history.listen((location, action) => {
      // console.log('listen location', location, action);
      // location.state.scrollToTop = false 时 不滚动到顶部
      if(location.state && !(location.state as any)['scrollToTop']){

      }else{
        scrollToTop();
      }
      setTimeout(() => {
        removeActiveClass();
        addActiveClass(location.pathname);
      }, 100);
    })
  }, [history]);

  return (
    <Navbar collapseOnSelect expand="lg" bg="primary" variant="dark" className="myHeader">

      <Navbar.Brand>
        <Link to="/home" >
          <img src={logo} alt="" className="logo" />
        </Link>
      </Navbar.Brand>

      <Navbar.Toggle aria-controls="responsive-navbar-nav" />

      <Navbar.Collapse id="responsive-navbar-nav">
        <Nav >
          {menusTreeObj}
          <span className="language"
            onClick={changeLanguage}
          >{intlGet('EN/CN')}</span>
        </Nav>

        {/* <Nav>
          <span className="language">EN/CN</span>
        </Nav> */}
      </Navbar.Collapse>
    </Navbar>
  )
}

export default Header;